import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import { ReactTooltipContent } from './ReactTooltipContent.component';

const CloseButtonTooltip = ({
  boundary,
  children,
  className,
  content,
  distance,
  flip,
  forwardedRef,
  maxWidth,
  onShow,
  placement,
  showClose,
  visible
}) => {
  const { onClick, onClose } = children.props;
  const [isVisible, setIsVisible] = useState(visible);
  const onHidden = (event) => {
    if (isVisible) {
      if (onClose) onClose(event);
      setIsVisible(false);
    }
  };
  const onOpen = (event) => {
    if (onClick) onClick(event);
    // Clicking the same element should toggle visibility
    setIsVisible(!isVisible);
  };
  return (
    <Tippy
      appendTo={() => document.body}
      arrow
      className="thd-tooltip"
      content={(
        <ReactTooltipContent
          className={className}
          onClose={onHidden}
          ref={forwardedRef}
          showClose={showClose}
        >
          {content}
        </ReactTooltipContent>
      )}
      interactive
      maxWidth={maxWidth}
      offset={[0, distance]}
      onClickOutside={onHidden}
      onHidden={onHidden}
      onShow={onShow}
      placement={placement}
      popperOptions={{
        strategy: 'fixed',
        modifiers: [{
          name: 'preventOverflow',
          options: {
            // equivalent to boundary: 'window' in v1, usually NOT necessary in v2
            rootBoundary: 'document',
          },
        }, {
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom']
          }
        }]
      }}
      visible={isVisible}
    >
      {React.cloneElement(children, {
        onClick: onOpen,
      })}
    </Tippy>
  );
};

CloseButtonTooltip.propTypes = {
  boundary: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  content: PropTypes.node.isRequired,
  distance: PropTypes.number,
  flip: PropTypes.bool,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  maxWidth: PropTypes.number,
  onShow: PropTypes.func,
  placement: PropTypes.string,
  showClose: PropTypes.bool,
  visible: PropTypes.bool
};

CloseButtonTooltip.defaultProps = {
  boundary: 'window',
  className: '',
  distance: 25,
  flip: true,
  forwardedRef: null,
  maxWidth: 500,
  onShow: () => {},
  placement: 'top',
  showClose: true,
  visible: false
};

export { CloseButtonTooltip };
